import { useEffect, SetStateAction, Dispatch } from 'react';
import { useSearchStore } from '@/stores/search';

export const useResetInputEvent = (
  setSearchValue: Dispatch<SetStateAction<string>>,
) => {
  const { isMainSearchOpen } = useSearchStore();

  useEffect(() => {
    if (!isMainSearchOpen) {
      setSearchValue('');
    }
  }, [isMainSearchOpen, setSearchValue]);
};
